import { render } from "./Pagination.vue?vue&type=template&id=f4e002b2"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/utils/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4e002b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4e002b2', __exports__)) {
    api.reload('f4e002b2', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=f4e002b2", () => {
    api.rerender('f4e002b2', render)
  })

}


export default __exports__